module.exports = __webpack_public_path__ + "static/media/Managing_Stress_Heart_Disease_294248HD.13e236fb.mp4";